"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = void 0;
var shadows_1 = __importDefault(require("../tokens/shadows"));
exports.shadows = shadows_1.default;
//# sourceMappingURL=shadows.js.map